document.addEventListener("alpine:init", () => {
  Alpine.data("productCard", (sectionId) => ({
    sectionId,
    // id, 
    indexSellingPlan: 1, // Index of the selling plan to use
    isLoading: false, // Flag to indicate loading state
    isLoadingOneTimePurchase: false, // Flag for one-time purchase loading state
    isLoadingSubscription: false, // Flag for subscription loading state
    isSubscribeItemAdded: false, // Flag to indicate if a subscription item was added
    isOneTimeAdded: false, // Flag to indicate if item was added to cart
    redirectToCheckout: false, // Flag to redirect to checkout after adding to cart
    samplePackProduct: false,            // Flag for sample pack product
    quantity: 1,                // Default quantity
    mainProduct: {},              // { id, title, options, variants }
    customTitles: [],             // Custom titles for variants
    customTags: [],             // Custom Tags for variants
    variants: [],                 // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
    variantOncePurchase: {},                 
    selectedVariant: null,        // Selected Variant
    selectedVariantNumber: 0,     // Selected Variant number of items
    skioDataObj: {},              // { id, metadata } 
    typePurchase: 'subscribe',    // Default purchase type
    selectedSellingPlan: {},      // Selected selling plan object { }
    selectedSellingPlanId: null,  // Selected selling plan
    priceFormatted: '',           // Formatted price string
    priceFormattedSkio: '',       // Formatted price string for SKIO

    /**
     * Initialize the product card component
     */
    init() {
      const skio_widget = document.querySelector(`.js-skio-selector`);
      if (skio_widget) {
        this.redirectToCheckout = skio_widget.dataset.redirectCheckout === 'true';
      }
      try {
        const json = this.$refs.skioTitlesJson?.textContent;
        this.customTitles = json ? JSON.parse(json) : [];
        console.log('Parsed skio_titles JSON:', this.customTitles);
      } catch (e) {
        console.warn("Invalid skio_titles JSON");
      }

      try {
        const json = this.$refs.skioTagsJson?.textContent;
        this.customTags = json ? JSON.parse(json) : [];
        console.log('Parsed skio_tags JSON:', this.customTags);
      } catch (e) {
        console.warn("Invalid skio_tags JSON");
      }

      this.parseProductJson();      // Parse the product JSON from the DOM
      this.getSkioData();           // Get SKIO data
      this.mapVariants();           // Map all variants with named option objects
 
      // Get variant from Alpine Store
      // this.selectedVariant = this.$store.ProductStore.variant;
      this.getVariantIdFromUrl(); 
      if (!this.selectedVariant && this.variants.length > 0) {
        this.selectedVariant = this.variants[this.selectedVariantNumber];
        console.log('[Skio] Fallback selectedVariant:', this.selectedVariant);
      }
      this.setInitialSellingPlan();
    },

    changeQuantity(action) {
      if ( this.typePurchase === 'subscribe') {
        console.warn('[Skio] Cannot change quantity for items on subscription. Please use the subscription management page to adjust quantities.');
        return;
      }
      if (action === 'increment') {
        this.quantity += 1;
      } else if (action === 'decrement' && this.quantity > 1) {
        this.quantity -= 1;
      }
    },

    /** 
     * Initialize the new product
     * @param {Object} product - The new product
     */
    initNewProduct(product) {
      this.mainProduct = product;
      this.selectedVariant = null;
      this.selectedSellingPlan = {};
      this.selectedSellingPlanId = null;
    
      this.$refs.productDataJson.textContent = JSON.stringify(product);
    
      this.getSkioData();
      this.mapVariants();
      this.getVariantIdFromUrl();
    
      // fallback
      if (!this.selectedVariant && this.variants.length > 0) {
        this.selectedVariant = this.variants[this.selectedVariantNumber];
        console.log('[Skio] Fallback selectedVariant:', this.selectedVariant);
      }
    
      this.setInitialSellingPlan();
    },

    getSellingPlanFromQueryParams() {
      const url = new URL(window.location.href);
      return url.searchParams.get("selling_plan");
    },

    /** 
     * Parse the product JSON from a DOM reference
     */
    parseProductJson() {
      const productData = JSON.parse(this.$refs.productDataJson.textContent);
      const packNumbers = JSON.parse(this.$refs.variantPackNumbersJson.textContent);
      const selectedVariantNumber = JSON.parse(this.$refs.selectedVariantNumber.textContent);

      this.selectedVariantNumber = parseInt(selectedVariantNumber - 1) || 0;
      this.mainProduct = productData;
      this.mainProduct.variants = this.mainProduct.variants.map(v => ({
        ...v,
        pack_number: packNumbers[v.id] || null
      }));
       // Check if sample pack is enabled
      //  {{ variant.metafields.custom.servings | default: 0 }}
      console.log('Parsed product data:', this.mainProduct);
    },

    /**
       * Get the variant ID from the URL query parameters
       * @return {Number|null} - Returns the variant ID or null if not found
       * */
    getVariantIdFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get('variant');
      
      if (!variantId) {
        console.warn('No variant ID found in URL');
        return;
      }
    
      const parsedId = parseInt(variantId);
      if (isNaN(parsedId)) {
        console.warn('Invalid variant ID in URL');
        return;
      }
    
      const foundVariant = this.variants.find(v => v.id === parsedId);
      if (foundVariant) {
        this.selectedVariant = foundVariant;
        console.log('Selected variant from URL:', this.selectedVariant);
      } else {
        console.warn('Variant from URL not found in product');
      }
    },

    /**
       * Observe changes in the variant block to update selected variant
       * This is useful for dynamic pages where the variant might change without a full page reload
       * @param {String} selector - The CSS selector for the variant block
       * */
    observeVariantBlockChanges() {
      const target = document.querySelector('.the-version__wrapper');
      console.log(target, '[Skio] Observing changes in .the-version__wrapper for variant updates...');
      if (!target) {
        console.warn('[Skio] .the-version__wrapper not found');
        return;
      }
    
      const observer = new MutationObserver(() => {
        console.log('[Skio] DOM changed in .the-version__wrapper — checking variant...');
        this.getVariantIdFromUrl();
      });
    
      observer.observe(target, { 
        subtree: true,
        attributeFilter: ['class'],
      });
    },
    /**
     * Change type purchase
    */ 
    changeTypePurchase(type) {
      this.typePurchase = type;
      console.log('this.typePurchase', this.typePurchase);
    },

    /**
     * Select a variant from the dropdown
     * @param {Object} variant - The variant object to select
     * */
    selectVariant(variant) {
      console.log('Selecting variant:', variant);
      this.selectedVariant = variant;
      this.selectedSellingPlanId = this.selectedVariant.selling_plan_id || null;
      this.selectedSellingPlan = this.skioDataObj.selling_plans.find(p => p.id === this.selectedSellingPlanId) || {};
      console.log('Selected selectedSellingPlanId:', this.selectedSellingPlanId);
      console.log('Selected variant:', this.selectedVariant);
    },

    /**
     * Get and normalize Skio data into simplified array
    */
    getSkioData() {
      // Accept subscription selling plans from any app (Skio on Fling, Seal Subscriptions on Bite Craft)
      const groups = (this.mainProduct.selling_plan_groups || []).filter(group => Array.isArray(group.selling_plans));
      const planList = groups.flatMap(group => group.selling_plans);

      if (!planList.length) {
        console.error('No valid subscription selling plan data found');
        this.skioDataObj = { selling_plans: [] };
        return;
      }

      this.skioDataObj = {
        selling_plans: planList.map(plan => {
          const adjustment = plan.price_adjustments?.[0] || {};
          return {
            id: plan.id,
            name: plan.name,
            discount: adjustment.value || 0,
            discount_type: adjustment.value_type || '',
          };
        })
      };

      console.log('Normalized skioDataObj:', this.skioDataObj);
    },

    /**
     * Parse the variant title to extract person count and tag
     * @param {String} title - The variant title to parse
     * @return {Object} - An object containing count, label, and tag
     * */
    // parseVariantTitle(title) {
    //   const match = title.match(/^(\d+)\s+items?$/i);
    //   const count = match ? parseInt(match[1]) : null;
    //   return { count };
    // },

    parseVariantTitle(title) {
      const match = title.match(/(\d+)/);
      return match ? parseInt(match[1]) : null;
    },

    /**
     * Create a normalized list of variants with key-value pair options
     */
    mapVariants() {
      this.variants = this.mainProduct.variants.map(variant => {
        const optionsObj = {};

        this.mainProduct.options.forEach((opt, i) => {
          const key = `option${i + 1}`; 
          optionsObj[key] = variant.options[i];
        }); 

        const sellingPlans = variant.selling_plan_allocations || [];
        let singleSellingPlanId = null;
        let discountedPrice = null;
        let discountValue = null;

        if (sellingPlans.length) {
          const allocation = sellingPlans.find(sp =>
            this.skioDataObj?.selling_plans?.some(p => p.id === sp.selling_plan_id)
          ) || null;
          singleSellingPlanId = allocation?.selling_plan_id || null;
          console.log('Single selling plan ID:', singleSellingPlanId);

          // The allocation carries the store-computed subscription price for this
          // variant, correct for every adjustment type (percentage, fixed_amount,
          // price). NOTE the template's historical semantics: discount_value is
          // bound in ctr-skio-box-alp-1.liquid as the SUBSCRIPTION PRICE and
          // (price - discount_value) as the savings — keep that contract.
          if (allocation && typeof allocation.price === 'number') {
            discountValue = allocation.price;
            discountedPrice = variant.price - allocation.price;
          }
        }

        const count = variant.pack_number ?? this.parseVariantTitle(variant.title);
    
        return {
          ...variant, 
          ...optionsObj,
          selling_plan_id: singleSellingPlanId,
          discounted_price: discountedPrice,
          discount_value: discountValue,
          parsedTitle: {
            count,
          }
        };
      });
      this.variantOncePurchase = this.variants.find(v => v.title.includes('1')) || this.variants[0];
      console.log('this.variantOncePurchase', this.variantOncePurchase); 
      console.log('this.variants.SKIO', this.variants); 
    },

    /**
     * Set the default selling plan when component is initialized
     */
    setInitialSellingPlan() {
      if (!this.skioDataObj?.selling_plans?.length || !this.selectedVariant) return;
    
      const planId = this.selectedVariant.selling_plan_id;
      if (!planId) return;
    
      const plan = this.skioDataObj.selling_plans.find(p => p.id === planId);
      if (plan) {
        this.selectedSellingPlan = plan;
        this.selectedSellingPlanId = plan.id;
      }
    },

    /**
     * Called when user selects a selling plan from dropdown
     */
    onChangeSellingPlan(event) {
      const selectedId = parseInt(event.target.value);
      this.selectedSellingPlanId = selectedId;
      this.selectedSellingPlan = this.skioDataObj.selling_plans.find(p => p.id === selectedId) || {};
      console.log('Selected selling plan:', this.selectedSellingPlan);
    },

    /** 
     * Get price from variant
    */
    getPriceCorrectFormat(variant) {
      if (!variant || typeof variant.price !== 'number') return '';
      return `$${(variant.price / 100).toFixed()}`;
    },

    /**
     * Get discount difference as formatted amount
    */
    getPriceDifference(variant) {
      if (!variant || typeof variant.price !== 'number') return '';

      // Prefer the allocation-derived saving computed in mapVariants (works for
      // any adjustment type); fall back to the percentage math for raw variants.
      // Per the template contract, discounted_price holds the savings amount.
      if (typeof variant.discounted_price === 'number' && variant.discounted_price > 0) {
        return `$${(variant.discounted_price / 100).toFixed()}`;
      }

      const sellingPlanId = variant.selling_plan_id;
      const plan = this.skioDataObj.selling_plans.find(p => p.id === sellingPlanId);

      if (!plan || plan.discount_type !== 'percentage') return '';

      const discount = parseFloat(plan.discount) || 0;
      const diff = (variant.price * discount) / 100;

      return `$${(diff / 100).toFixed()}`;
    },

    /**
     * Get formatted discounted price based on selected plan
     */
    getDiscountedPrice(variant) {
      if (!variant || typeof variant.price !== 'number') return '';
      
      // Prefer the allocation-derived subscription price computed in mapVariants
      // (per the template contract, discount_value holds the subscription price).
      if (typeof variant.discount_value === 'number' && variant.discount_value > 0) {
        return `$${(variant.discount_value / 100).toFixed()}`;
      }

      const sellingPlanId = variant.selling_plan_id;
      const plan = this.skioDataObj.selling_plans.find(p => p.id === sellingPlanId);

      if (!plan || plan.discount_type !== 'percentage') {
        return this.getPriceCorrectFormat(variant);
      }

      const discount = parseFloat(plan.discount) || 0;
      const discountValue = (variant.price * discount) / 100;
      const discounted = variant.price - discountValue;

      return `$${(discounted / 100).toFixed()}`;
    },

    /**
     * Handle quick checkout action
     * This function can be customized to implement quick checkout logic
     * @param {Object} variant - The selected variant object
     * */
    handleQuickCheckout() {
      this.isLoading = true;
      if (this.typePurchase === 'one-time') {
        this.isLoadingOneTimePurchase = true;
      } else if (this.typePurchase === 'subscribe') {
        this.isLoadingSubscription = true;
      }
      const form = this.$root.querySelector('form.shopify-product-form');
      if (!form) {
        console.error('[Skio] Product form not found');
        this.isLoading = false;
        this.isLoadingSubscription = false;
        this.isLoadingOneTimePurchase = false;
        return;
      }
    
      const formData = new FormData(form);
      const id = formData.get('id');
      const selling_plan = formData.get('selling_plan');
      const quantity = parseInt(formData.get('quantity') || 1);
    
      if (!id) {
        alert("Please select a variant before proceeding.");
        this.isLoading = false;
        this.isLoadingSubscription = false;
        this.isLoadingOneTimePurchase = false;
        return;
      }
    
      const payload = {
        id,
        quantity,
      };
    
      if (selling_plan) {
        payload.selling_plan = selling_plan;
      }
    
      fetch('/cart/add.js', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (!res.ok) {
          return res.text().then(text => {
            throw new Error('Failed to add product to cart: ' + text);
          });
        }
        return res.json();
      })
      .then(result => {
        console.log('[Skio] Product added to cart:', result);
        if (this.typePurchase === 'one-time') {
          this.isOneTimeAdded = true;
        } else if (this.typePurchase === 'subscribe') {
          this.isSubscribeItemAdded = true;
        } 
        if (this.redirectToCheckout) {
          setTimeout(() => { 
            window.location.href = '/checkout'; 
          }, 500);
        } else {
          document.dispatchEvent(new CustomEvent('product:added'));
        }
        
        
        this.isLoading = false;
        this.isLoadingSubscription = false;
        this.isLoadingOneTimePurchase = false;
        this.isAddedToCart = true;
      })
      .catch(error => {
        this.isLoading = false;
        this.isLoadingSubscription = false;
        this.isLoadingOneTimePurchase = false;
        console.error('[Skio] Quick checkout error:', error);
        console.warn('Failed to add item to cart. Please try again.');
      });
    },

    /**
     * Load the product
     * @param {string} productHandle - The product handle
     * @param {string} preselectedVariantId - The preselected variant ID
     */
    loadProduct(productHandle, preselectedVariantId = "") {
      const isProductPage = window.location.pathname.startsWith('/products/');
      if (!isProductPage) {
        window.location.href = `/products/${productHandle}?variant=${preselectedVariantId}`;
      }

      const url = `/products/${productHandle}?${
        preselectedVariantId ? `variant=${preselectedVariantId}` : ""
      }&sections=${this.sectionId}`;
      const productUrl = `/products/${productHandle}.js`;
      let productDetails = null;
      console.log("Loading product:", productHandle, "with section ID:", this.sectionId);
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          return response.json();
        })
        .then((product) => {
          if (!product[this.sectionId]) {
            console.error("Product section not found");
            return;
          }
          console.log("Loadeded product:", product);
          const container = document.createElement("div");
          container.innerHTML = product[this.sectionId];
          const productDetails = container.querySelector(
            "#MainProduct-" + this.sectionId
          );


          if (this.$refs.productCardRef) {
            console.log("Replacing product card with new content", productDetails);
            this.$refs.productCardRef.replaceWith(productDetails);
            // this.reExecuteScript();
          } else {
            console.error("Reference to productCardRef not found");
          }
          return fetch(productUrl);
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch product data");
          }
          return response.json();
        })
        .then((productData) => {
          console.log("Product data loaded:", productData);
          this.$nextTick(() => {
            this.initNewProduct(productData);
            // Alpine.initTree(productDetails); 
          });

          if (isProductPage) {
            window.history.pushState(
              { urlPath: productHandle },
              "",
              `/products/${productHandle}`
            );
          }
          // window.history.pushState(
          //   { urlPath: productHandle },
          //   "", 
          //   productHandle
          // );
        })
        .catch((error) => {
          console.error("Error loading product:", error);
        });
      },
  }));
});
